import { DEFAULT_LOCALE, LocaleSchema, type Locale } from '@ghostscreen/contracts';

/** Each language is listed in its own name, so anyone can find theirs. */
export const LANGUAGE_OPTIONS: ReadonlyArray<{ value: Locale; label: string }> = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'ar', label: 'العربية' },
];

/** "ar-EG" → "ar"; anything we don't translate → null. */
export function toSupportedLocale(tag: string | null | undefined): Locale | null {
  if (!tag) return null;
  const base = tag.toLowerCase().split('-')[0];
  const parsed = LocaleSchema.safeParse(base);
  return parsed.success ? parsed.data : null;
}

/** First browser language we translate, else English. */
export function pickBrowserLocale(preferred: readonly string[]): Locale {
  for (const tag of preferred) {
    const locale = toSupportedLocale(tag);
    if (locale) return locale;
  }
  return DEFAULT_LOCALE;
}

/**
 * Words come from the language; dates, numbers and digits come from the
 * reader's region. "ar" for a browser set to "ar-EG" formats as Egyptian Arabic.
 */
export function regionalTag(locale: Locale, preferred: readonly string[]): string {
  return preferred.find((tag) => tag.includes('-') && toSupportedLocale(tag) === locale) ?? locale;
}
